import * as React from 'react';
import { Checkbox } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

const BlueCheckbox = withStyles({
    root: {
        color: '#1cabe2',
        //'&$checked': {
        //    color: '#007bff',
        //},
        padding: 0
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);

export const CheckBox = (props: any) => {
    var disabled = props.disabled ? true : false
    var value = props.value ? props.value : false
    var defVal = props.value == true ? true : false
    return (
        <BlueCheckbox
            disabled={disabled}
            checked={defVal}
            inputProps={{ 'aria-label': 'secondary checkbox' }}
            {...props}
            value={value}
        />
    )
}

export default CheckBox;